import React from 'react';
import QualityIcon from 'pubweb-react-components/dist/components/Icons/QualityIcon';
import Helmet from 'react-helmet';
import { saveUTMSessionParams } from "pubweb-smokey/dist/utils/utils";

import LandingHeader from '../components/LandingHeader/LandingHeader';

import '../styles/index.scss';

import SubpageContainer from '../styles/SubpageStyles';
import SubpageBody from "../components/SubpageBody/SubpageBody";
import SubpageFooter from "../components/SubpageFooter/SubpageFooter";

import { onHelmetChangeClientState } from '../utils/Analytics';
import ScriptTags from '../components/ScriptTags';

import ImageSet from '../utils/ImageSets';

import mobileQuality from '../images/mobile/subpages-quality-mobile.jpg';
import tabletQuality from '../images/tablet/subpages-quality-tablet.jpg';
import desktopQuality from '../images/desktop/subpages-quality-header.jpg';

const Quality = (props) => {

    // save any utm params to local session cache
    if(props.location && props.location.search) {
        saveUTMSessionParams(props.location.search);
    }

    var backgroundImages = new ImageSet(mobileQuality, tabletQuality, desktopQuality);

    return (<SubpageContainer backgroundImages={backgroundImages}>
        <LandingHeader />
        <SubpageBody
            category='quality'
            headerText="Quality"
            subHeaderText="Clayton Built&#174; Homes: Quality You Can Trust"
            formHeading="Don't take our word for it, though.">
            <div className="movin-header">
                <QualityIcon />
                <h3>Don't settle for less.</h3>
            </div>
            <div className="body-container">
                <div className="body-column-left">
                    The quality of a home is in more than just brand name materials and modern, efficient features. Smart construction helps trained craftsmen build manufactured and modular homes that are strong and durable.  Our streamlined home building process means that homes can be constructed off-site in climate controlled building facilities in significantly less time than most traditional home builds.
                </div>
                <div className="body-column-right">
                    And, Clayton Built&#174; homes are all constructed to high standards of strength and durability under the watchful gaze of internal inspectors, so you can rest assured that the home you choose will stand up to a lifetime of baby&rsquo;s firsts, birthday parties, puppy paws and Mother Nature.
                </div>
            </div>
        </SubpageBody>
        <SubpageFooter
            linkNext="/style"
            linkPrev="/affordability"
            textNext="Style"
            textPrev="Affordability"
        />
        <ScriptTags />
        <Helmet
            onChangeClientState={onHelmetChangeClientState}
            script={[
                {
                    type: 'text/javascript',
                    innerHTML: `
                    if (typeof fbq !== 'undefined'){
                        fbq('track', 'PageView');
                    }
                    if (typeof gtag !== 'undefined'){
                        gtag('event', 'page_view', {'send_to': 'AW-1040796449','dynx_itemid': 'HIM2018','dynx_pagetype': 'Quality'});
                        gtag('event', 'conversion', {
                            'allow_custom_scripts': true,
                            'send_to': 'DC-6346097/fall1003/fall10+standard'
                        });
                    }
                `
                }
            ]}
        >
            <title>Have It Made | Quality | Clayton Homes</title>
        </Helmet>
    </SubpageContainer>);
};

export default Quality;



// WEBPACK FOOTER //
// ./src/pages/quality.js